import { valuesFromConfiguration, type BotFormValues } from "./bot-mutation.js";
import { botRevisionView } from "./models.js";
import spy from "./templates/monthly-trend-cash-graph/SPY.json";
import qqq from "./templates/monthly-trend-cash-graph/QQQ.json";
import iwm from "./templates/monthly-trend-cash-graph/IWM.json";
import gld from "./templates/monthly-trend-cash-graph/GLD.json";
import tlt from "./templates/monthly-trend-cash-graph/TLT.json";

// Wire payloads are also usable directly with TradingEngine's create-bot API.
export const monthlyTrendTemplates = [spy, qqq, iwm, gld, tlt] as const;

export function monthlyTrendTemplateValues(symbol: string): BotFormValues {
  const template = monthlyTrendTemplates.find((item) => item.configuration.symbol === symbol);
  if (template === undefined) throw new Error("Unknown monthly trend/cash template symbol.");
  return valuesFromConfiguration(
    botRevisionView({ id: "local-template", ...template.configuration }),
    template.name,
  );
}
